<template>
  <div class="container">

    <div class="content">


      <div class="chat list-scroll" id="chat-record">

        <template v-for="row in chatHistory">

          <div class="message-item-left" :key="row.content" v-if="row.type == 'system'">

            <div style="display: flex;">

              <div class="avatar">
                <img style="width: 100%;" :src="require(`@/assets/system.jpg`)" alt="" srcset="" />
              </div>

              <div class="message" style="background: white;">
                <!-- <template>{{ row.content }} </template> -->
                <div v-html="row.content"></div>
              </div>

            </div>



          </div>


          <div class="message-item-right" :key="row.content" v-if="['image', 'text'].includes(row.type)">

            <div class="flex" style="position: relative;justify-content: end;width: 100%;">
              <div style="display:flex;justify-content: end;width:100%">

                <div class="message-right">
                  <template v-if="row.type == 'text'">
                    {{ row.content }}
                  </template>

                  <template v-if="row.type == 'image'">

                    <img :src="row.content" style="width: 10rem;">
                  </template>

                </div>
                <div class="avatar">
                  <img style="width: 100%;" :src="require(`@/assets/user.jpg`)" alt="" srcset="" />
                </div>
                <!-- <div style="text-align: right;" class="name">YOU</div> -->

              </div>

            </div>



          </div>
        </template>

      </div>
      <div style="height: 6rem;background:#F7F7F7">
        <div class="enter">

          <input type="text" style="width: calc(100% - 7rem);" v-model="currentInput" :disabled="spinning"
            placeholder="请输入" @keyup.enter="sendToserve" />

          <div style="width: 7rem;display: flex;justify-content: space-evenly;">

            <button v-if="currentInput" style="    background: rgb(8, 192, 94);
    border: none;color: white;height: 3rem;width: 5rem;border-radius: 0.5rem;" @click="sendToserve">发送</button>
            <a-upload v-else style="margin-top:0.5rem" accept="image/*" :show-upload-list="false"
              :custom-request="handleChange">

              <!-- <a-button icon="plus-circle" size="small"  class="ant-upload-text"></a-button> -->

              <a-icon type="plus-circle" class="icon" />
            </a-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


import { putAction, download, getAction } from '@/request/http.js'


export default {
  data() {
    return {
      chatHistory: [],
      spinning: false,
      session_id: "",
      currentInput: "",
      imgList: [],
      agent:""
    }
  },
  mounted() {


    this.chatHistory.push({
      "type": "system",
      "content": "<span>您好，我是一名编织袋销售顾问, 请问有什么可以帮助您的?</span>"
    })

    // this.chatHistory.push({
    //   "type": "text",
    //   "content": "您好，我是一名编织袋销售顾问, 请问有什么可以帮助您的?"
    // })

    this.agent = location.href.split('//').pop().match(/(?<=\/).*?(?=#)/g)[0].replace('?','')
    



  },
  methods: {


    init() {

    },







    async sendToserve() {
      if (!this.currentInput) {
        this.$message.warning('请输入内容')
        return false
      }
      this.spinning = true;

      this.chatHistory.push({
        type: "text",
        content: this.currentInput
      })


      let paylaod = {
        prompt: this.currentInput,
        agent:this.agent
      }

      if (this.imgList.length) {
        paylaod.image = this.imgList
      }

      if (this.session_id) {
        paylaod.session_id = this.session_id
      }
      this.chatHistory.push({
        type: "system",
        content: "正在回复中......"
      })
      fetch(`${process.env.VUE_APP_BASE_URL}chat`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(paylaod)
      }).then(res => res.json()).then(res => {

        if (res.code == -1) {
          this.$message.warning(res.message)
          return false;
        }

        this.chatHistory.pop()

        this.chatHistory.push({
          type: "system",
          content: this.dealMsg(res.data)
        })
        if (res.session_id) {
          this.session_id = res.session_id
        }
        this.imgList = []
        this.currentInput = ''
        this.spinning = false;

      }).finally(() => {
        this.currentInput = ''
        this.spinning = false;
      })


    },


    handleChange(file) {
      const formData = new FormData();
      console.log('file', file)
      formData.append('files', file.file);

      this.loading = true;


      fetch(`${process.env.VUE_APP_BASE_URL}upload`, {
        method: "post",
        body: formData
      }).then(res => res.json()).then(res => {
        console.log('res', res)
        if (res.code == -1) {
          this.$message.warning(res.message)
          return false;
        }

        this.chatHistory.push({
          type: "image",
          content: `${process.env.VUE_APP_BASE_URL}image/${res.data}`
        })
        this.imgList.push(`${process.env.VUE_APP_BASE_URL}image/${res.data}`)
      }).finally(() => {
        this.loading = false;
      })


    },

    dealMsg(msg) {
      msg = msg.split('\n')
      msg = msg.map(ele => {
        if (ele.match(/https.*?(jpg|png|jpeg)/)) {
          return `<img src="${ele.match(/https.*?(jpg|png|jpeg)/)[0]}">`
        }
        //  else if (ele.match(/http.*?\.mp4/)) {
        //   return `<video src="${ele.match(/http.*?\.mp4/)[0]}" controls></video>`
        // }
        else if (!ele) {
          return `<br/>`
        } else {
          return `<span>${ele}</span>`
        }
      })

      return msg.join('<br/>')
    }


  },
  created() {

  },
  components: {
  }
}
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  background: #EDEDED;

}

.title {

  font-size: 1.7rem;

  font-weight: 500;
  color: #FFFFFF;
  padding-top: 3rem;
  justify-content: start;
  align-items: center;

}

.back {
  width: 0.7rem;
  margin-left: 2rem;
  height: 1.3rem;
}

.content {
  width: 100%;
  /* height: calc(100% - 5rem); */
  height: 100%;
  position: absolute;
  bottom: 0;
  border-radius: 5rem 5rem 0 0;
  overflow: hidden;
  /* box-shadow: 0px -1px 20px 15px rgba(0, 0, 0, 0.1); */

  /* background: white; */
}

.chat {
  width: 100%;
  height: calc(100% - 6rem);
  padding: 2rem 1rem;

}

.enter {
  width: 100%;
  height: 6rem;
  /* background: yellow; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  /* background: rgba(240, 240, 240, 0.7); */
  font-size: 1.6rem;
}

.enter input {
  width: calc(100% - 7rem);
  height: 4rem;
  border-radius: 0.5rem;
  background: white;
  border: none;
}

.enter img {
  width: 5rem;
  padding: 0.5rem 1.5rem;
  background: rgba(30, 27, 193, 1);
  border-radius: 2rem;
}

.avatar {
  width: 4rem;
  border-radius: 0.5rem;
  overflow: hidden;
  height: 4rem;
}

.name {
  font-weight: bold;
  font-size: 1.6rem;
  font-weight: 700;
  color: white;
}

.time {
  font-size: 1.2rem;
  font-family: PingFangSCRegular;
  font-weight: 400;
  color: #C3C3C3;
}

.message {
  /* padding: 1rem;
  line-height: 1.6rem;
  letter-spacing: 0.1rem;
  max-width: calc(100% - 4.4rem);
  margin-left: 1rem;
  position: relative;
  word-break: break-all;
  background: #2196f333;
  border-radius: 1.5rem;
  font-size: 1.4rem;
  font-weight: 500; */
  /* color: black; */
  padding: 1rem;
  /* line-height: 4rem; */
  letter-spacing: 0.1rem;
  max-width: calc(100% - 10rem);
  margin-left: 1rem;
  position: relative;
  word-break: break-all;
  border-radius: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
}

.message-item-left {

  width: 100%;
  margin-bottom: 1rem;
  /* padding: 0 20% 0 0; */

}

.message-item-right {

  width: 100%;
  margin-bottom: 1rem;
  /* padding: 0 0 0 20%; */
  display: flex;
  flex-direction: column;
  align-items: end;

}

.recommend div {
  width: 100%;
  padding: 0.5rem 1rem;
  margin-top: 0.8rem;
  background: rgba(77, 62, 177, 1);
  border-radius: 2rem;
  color: white;
}

/* .recommend div:hover {

background: #12ba104a;


} */

.message-right {
  /* width: fit-content; */
  padding: 1rem;
  max-width: calc(100% - 10rem);
  margin-right: 1rem;
  position: relative;
  word-break: break-all;
  border-radius: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
  background: #95EC69;
  /* color: white; */
  /* line-height: 1.6rem; */
}

.message-icon {
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 1.4rem;
  left: -0.5rem;
  background: #fc7b5f;
  transform: rotate(45deg);
}

.message-icon2 {
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 1.4rem;
  right: -0.5rem;
  background: #fed1c6;
  transform: rotate(45deg);
}

.icon>>>svg {
  width: 2.5rem !important;
  height: 2.5rem !important;
}
.message >>> img{
  width: 20rem;
}
</style>

<style>
.message a {
  color: #E0E0E0 !important;
}
</style>
